import { useCurrentPlanApi } from "@/react/components/SettingsApp/Plan/hooks/useCurrentPlanApi";
import { isCommunityAdmin } from "@/react/helpers/communityMemberHelpers";
import { isPlanProfessional } from "@/react/helpers/planHelpers";
import { useExperimentEnabled } from "@/react/hooks/experiments/useExperimentEnabled";
import { useFlagValue } from "@/react/hooks/experiments/useFlagEnabled";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";
import { usePunditUserContext } from "@circle-react/contexts";

export const useShouldShowPlanTrial = () => {
  const { currentPlan } = useCurrentPlanApi();
  const { isCommunityOnTrial, isCommunityOnPaidPlan } = usePlanStatus();
  const { currentCommunityMember, currentCommunity } = usePunditUserContext();

  const flagData = useFlagValue("business_plan_trial_test");
  const variantType =
    flagData && typeof flagData === "object" && "type" in flagData
      ? (flagData as { type: string }).type
      : undefined;

  const isBusinessPlanTrialTestEnabled = useExperimentEnabled(
    "business_plan_trial_test",
  );

  const isVariantEnabled =
    isBusinessPlanTrialTestEnabled && variantType === "variant_a";

  const isPlanTrialActive = currentPlan?.plan_trial?.active || false;
  const isPlanTrialOptedOut = currentPlan?.plan_trial?.opted_out || false;
  const isPlanTrialConverted = currentPlan?.plan_trial?.converted || false;
  const isAdmin = isCommunityAdmin(currentCommunityMember);
  const isSubscriptionActive =
    currentCommunity?.subscription?.status === "active";

  return (
    isAdmin &&
    isVariantEnabled &&
    !isCommunityOnTrial &&
    !isPlanTrialActive &&
    !isPlanTrialOptedOut &&
    !isPlanTrialConverted &&
    isCommunityOnPaidPlan &&
    isSubscriptionActive &&
    currentPlan &&
    isPlanProfessional(currentPlan.tier)
  );
};
